// npm
import React from 'react'
import PropTypes from 'prop-types'

// react
import { AnswerBox } from './answer-box'
import { ShortTextAnswerForm } from '../answer_forms/short_text'

// redux
import { getLocalAnswer } from 'redux/reducers/exam/content/questions/question/selectors'
import { getResumedAnswer } from 'redux/reducers/exam/content/questions/question/short_text/selectors'


class ShortTextAnswerBox extends React.Component
{
	constructor(props)
	{
		super(props);
		this.setUpExtractionFunctions();
		this.setUpTransformationFunctions();
	}

	setUpExtractionFunctions()
	{
		this.extractInitialAnswer = () => '';

		this.extractResumedAnswer = () => getResumedAnswer(this.props.data) || '';

		this.extractFormData = () => ({});
	}

	setUpTransformationFunctions()
	{
		this.getFormValue = (e) => e.target.value;
		this.toFormValue = (localAnswer) => localAnswer || '';
		this.toLocalAnswer = (formValue) => formValue;
		this.toServerAnswer = (localAnswer) => ({ answerText: localAnswer });
	}

	render()
	{
		const answerBoxProps = {
			FormComponent: ShortTextAnswerForm,
			questionData: this.props.data,
			getFormValue: this.getFormValue,
			toFormValue: this.toFormValue,
			toLocalAnswer: this.toLocalAnswer,
			toServerAnswer: this.toServerAnswer,
			extractFormData: this.extractFormData,
			extractInitialAnswer: this.extractInitialAnswer,
			extractResumedAnswer: this.extractResumedAnswer,
		};

		return <AnswerBox {...answerBoxProps}/>;
	}
}

ShortTextAnswerBox.propTypes = {
	data: PropTypes.object.isRequired
}


export { ShortTextAnswerBox }
